<div class="pure-g m-t-16" style="align-items: center; display: flex; justify-content: flex-end">
  <div class="header-actions">
    <app-parts-management-bulk-upload></app-parts-management-bulk-upload>
    @if (isPartAddEnabled()) {
      <mc-button
        label="Add new"
        routerLink="/master-data/parts-management/add-new"
        variant="filled"
        appearance="primary"
        fit="small"></mc-button>
    }
  </div>
</div>

<div class="pure-g m-t-8 quick-filter-box">
  <div class="pure-u-md-22-24 pure-u-lg-22-24 p-l-4 applied-filter-holder" style="display: flex; align-items: center">
    @for (taggedFilter of taggedFilters; track taggedFilter.key) {
      <div class="m-r-4" style="white-space: nowrap">
        {{ taggedFilter.key }}
      </div>

      @if (isArrayType(taggedFilter.value)) {
        @if (taggedFilter.key == 'Part Number' && getTaggedPartNo()) {
          <app-tag-with-overflow
            [data]="getTaggedPartNo()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectPartNo()"></app-tag-with-overflow>
        }

        @if (taggedFilter.key == 'Part Group' && getTaggedPartGroup()) {
          @for (taggedPartGroup of getTaggedPartGroup(); track taggedPartGroup) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedPartGroup().indexOf(taggedPartGroup))"
              (keydown)="unselectSpecificFilter(taggedFilter, getTaggedPartGroup().indexOf(taggedPartGroup))">
              {{ getTaggedFilterValue(taggedFilter, getTaggedPartGroup().indexOf(taggedPartGroup)) }}</mc-tag
            >
          }
        }

        @if (taggedFilter.key == 'Part Manufacturer' && getTaggedManufacturerCode()) {
          @for (taggedManufacturerCode of getTaggedManufacturerCode(); track taggedManufacturerCode) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedManufacturerCode().indexOf(taggedManufacturerCode))"
              (keydown)="unselectSpecificFilter(taggedFilter, getTaggedManufacturerCode().indexOf(taggedManufacturerCode))">
              {{ getTaggedFilterValue(taggedFilter, getTaggedManufacturerCode().indexOf(taggedManufacturerCode)) }}</mc-tag
            >
          }
        }

        @if (taggedFilter.key == 'Description' && getTaggedDescription()) {
          <app-tag-with-overflow
            [data]="getTaggedDescription()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectDescription()"></app-tag-with-overflow>
        }

        @if (taggedFilter.key == 'Active' && getTaggedActive()) {
          @for (activeValue of getTaggedActive(); track activeValue) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificActiveFilter(activeValue)"
              (keydown)="unselectSpecificActiveFilter(activeValue)">
              {{ activeValue }}</mc-tag
            >
          }
        }

        @if (taggedFilter.key == 'Core' && getTaggedCore()) {
          @for (coreValue of getTaggedCore(); track coreValue) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificCoreFilter(coreValue)"
              (keydown)="unselectSpecificCoreFilter(coreValue)">
              {{ coreValue }}</mc-tag
            >
          }
        }

        @if (taggedFilter.key == 'Deduct Core Value' && getTaggedDeductCore()) {
          @for (deductCoreValue of getTaggedDeductCore(); track deductCoreValue) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificDeductCoreFilter(deductCoreValue)"
              (keydown)="unselectSpecificDeductCoreFilter(deductCoreValue)">
              {{ deductCoreValue }}</mc-tag
            >
          }
        }
      }
    }
    @if (taggedFilters.length > 0) {
      <a>
        <mc-button
          class="clear-btn"
          variant="plain"
          appearance="primary"
          fit="small"
          padding="default"
          (click)="clearAllSelectedFilters()"
          (keydown)="clearAllSelectedFilters()">
          Clear All
        </mc-button>
      </a>
    }
  </div>
  <div class="pure-u-md-2-24 pure-u-lg-2-24" style="display: flex; justify-content: flex-end">
    <div class="utility-buttons-row">
      <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
        <mc-button
          class="utility-button-inner"
          slot="trigger"
          label="Button"
          icon="sliders-horizontal"
          variant="filled"
          appearance="neutral"
          hiddenlabel
          padding="default"
          fit="medium"
          (click)="showAdvanceFiltersModal()"
          (keydown)="showAdvanceFiltersModal()">
        </mc-button>
        <span>Filters</span>
      </mc-tooltip>
      @if (authPolicies.canViewPartManagement) {
        <mc-button
          class="utility-button"
          label="Button"
          variant="filled"
          appearance="neutral"
          fit="medium"
          [loading]="isDownload"
          icon="tray-arrow-down"
          hiddenlabel
          padding="default"
          (click)="onDownload()"
          (keydown)="onDownload()">
        </mc-button>
      }
    </div>
  </div>
</div>
<mc-modal
  backdropcloseactiondisabled
  [open]="showAdvanceFilters"
  (closed)="closeAdvanceFiltersModal()"
  heading="Filters"
  fit="small"
  dimension="large">
  <app-parts-management-advance-filter
    [isPartsManagementList]="isPartsManagementList"
    [bindMultiSelects]="showAdvanceFilters"
    [partsManagementFilterForm]="filterFormGroup.controls.partsManagementFilterForm"></app-parts-management-advance-filter>
</mc-modal>
